require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-jabing.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-jabing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-jabing!./.cache/json/betreuungseinrichtungen-oberwart-jabing.json
// module id = 1007
// module chunks = 231608221292675